import React, { KeyboardEvent, useState } from 'react';
import SearchIcon from '@mui/icons-material/Search';
import { Box, InputAdornment, SvgIcon, TextField } from '@mui/material';

type SearchFieldPropsType = {
  searchItem: (value: string) => void
  searchFailed: boolean
}

export const SearchField = React.memo((props: SearchFieldPropsType) => {
  console.log('ListToolbar is called')
  const [inputValue, setInputValue] = useState('');

  const handleKeyPress = (e: KeyboardEvent<HTMLDivElement>) => {
    if (e.key === 'Enter') {
      console.log('error', props.searchFailed);
      props.searchItem(inputValue);
    }
  };

  return (
            <Box sx={{ mt: 3, width: '100%' , float: 'right'}}>
              <TextField
                id="outlined-error-helper-text"
                helperText={props.searchFailed ? 'No Item has been found....' : ' '}
                error={props.searchFailed}
                value={inputValue}
                onKeyPress={(e) => handleKeyPress(e)}
                onChange={(e) => setInputValue(e.currentTarget.value)}
                fullWidth
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SvgIcon
                        fontSize="small"
                        color="action"
                      >
                        <SearchIcon />
                      </SvgIcon>
                    </InputAdornment>
                  )
                }}
                placeholder='Search'
                variant="outlined"
              />
            </Box>
  )
})
